import { useMemo } from 'react';
import { Building } from '../../../../types/protocols';
import { ComponentLifetime, TemplatesByType } from '../../TemplatesEditor/types';
import type { MaintenancePlan } from '../../../../Helpers/maintenanceCostUtils';
import { useBuildComponentTypes } from '../../../../contexts/BuildComponentTypesContext';
import { computePlanDiff, PlanDiff } from '../utils/planDiff';

interface UsePlanDiffOptions {
    activePlan: MaintenancePlan | null | undefined;
    draft: MaintenancePlan;
    building: Building | null;
    componentLifetimes: Record<string, ComponentLifetime>;
    maintenanceTemplates: TemplatesByType;
    yearsToShow: number;
    /** Skip the computation while nothing shows it */
    enabled?: boolean;
}

/** The draft compared with the active plan, live; null without an active plan. */
export const usePlanDiff = ({
    activePlan,
    draft,
    building,
    componentLifetimes,
    maintenanceTemplates,
    yearsToShow,
    enabled = true
}: UsePlanDiffOptions): PlanDiff | null => {
    const { types } = useBuildComponentTypes();

    return useMemo(() => {
        if (!enabled || !activePlan || !building) return null;
        return computePlanDiff({
            active: activePlan,
            draft,
            building,
            componentLifetimes,
            maintenanceTemplates,
            baseTypeOf: componentType => types[componentType]?.baseType,
            yearsToShow
        });
    }, [enabled, activePlan, draft, building, componentLifetimes, maintenanceTemplates, types, yearsToShow]);
};
